import dkAxios from '@/jslib/dk-axios'

export const getOrderList = data => dkAxios({
  url: '/v1/cms/Order',
  method: 'GET',
  params: data,
});

export const getOrderDetail = data => dkAxios({
  url: `/v1/cms/Order/${data}`,
  method: 'GET',
});

export const closeRefundOrder = data => dkAxios({
  url: '/v1/cms/Order/refund',
  method: 'POST',
  data,
});
export const updateOrder = data => dkAxios({
  url: '/v1/cms/Order/editOrder',
  method: 'POST',
  data,
});

export const saveOrder = data => dkAxios({
  url: '/v1/cms/Order/addOrder',
  method: 'POST',
  data,
});

export const closeCancelOrder = data => dkAxios({
  url: '/v1/cms/Order/cancel',
  method: 'POST',
  data,
});

export const offlinePayOrder = data => dkAxios({
  url: '/v1/cms/Order/offlinePay',
  method: 'POST',
  data,
});

export const confirmOrder = data => dkAxios({
  url: '/v1/cms/Order/confirm',
  method: 'POST',
  data,
});

export const deliveryOrder = data => dkAxios({
  url: '/v1/cms/Order/ship',
  method: 'POST',
  data,
});

export const chengMoney = data => dkAxios({
  url: `/v1/cms/Order/${data.uuid}`,
  method: 'PUT',
  data,
});

export const getPointOrderList = data => dkAxios({
  url: '/v1/cms/PointOrder',
  method: 'GET',
  params: data,
});

export const getPointOrderDetail = data => dkAxios({
  url: `/v1/cms/PointOrder/${data}`,
  method: 'GET',
});

export const closeRefundPointOrder = data => dkAxios({
  url: '/v1/cms/PointOrder/refund',
  method: 'POST',
  data,
});

export const confirmPointOrder = data => dkAxios({
  url: '/v1/cms/PointOrder/confirm',
  method: 'POST',
  data,
});

export const deliveryPointOrder = data => dkAxios({
  url: '/v1/cms/PointOrder/ship',
  method: 'POST',
  data,
});

export const getExportUrl = data => dkAxios({
  url: '/v1/cms/Order/export',
  method: 'GET',
  params: data,
});


export const getExportUrlPoint = data => dkAxios({
  url: '/v1/cms/PointOrder/export',
  method: 'GET',
  params: data,
});



// WEBPACK FOOTER //
// ./src/api/order.js